export const footer = {
	title: 'Fakturačné údaje',
	id: 'IČO',
	taxId: 'IČ DPH',
	registration: [
		'Spoločnosť PaRELI s.r.o. je zapísaná v Obchodnom registri',
		'Okresného súdu Bratislava 1, vložka č. 89945/B',
	],
};
